import { render, staticRenderFns } from "./SelectGoodsDialog.vue?vue&type=template&id=10ec9b8e&scoped=true&lang=pug&"
import script from "./SelectGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./SelectGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SelectGoodsDialog.vue?vue&type=style&index=0&id=10ec9b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec9b8e",
  null
  
)

export default component.exports